module.exports = __webpack_public_path__ + "static/media/image_27.1f8671e2.png";